import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Grid, Box, CssBaseline } from "@mui/material";
import { GeoPoint } from "firebase/firestore";


import {
  GeneralAdminRoutes,
  drawerWidth,
  mainLayoutStyles,
  routes,
  showNotification,
} from "../../../../../constants";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import DetailsPageHeader from "../../../../../common/DetailsPageHeader";

import {
  GAOrgDetailsDataFieldsSection,
  GAOrgDetailTable,
} from "../../components/components";
import ImagePreviewModal from "../../../../../common/ImagePreviewModal";
import { useOrganizationContext } from "../../../../../providers/OrganizationAdmin/OrganizationProvider";
import {
  updateOrganization,
  uploadOrgImageToStorage,
  getSingleOrg,
  checkOrgHandleAvailability,
  normalizeHandle,
} from "../../../../../modules/OrgProf/hook/Organizationhook";
import { Toast } from "../../../../../common/alert";
import { useAuth } from "../../../../../hooks";
import { getOrganizationReports } from "../../../GAContentModeration/hooks/ContentReportsHooks";

const GAOrganizationDetailsContainer = () => {
  const { handleGetAllOrganizations, allOrganization, setLoading, loading } =
    useOrganizationContext();
  const {
    currentUser,
    setNavigationRoute,
    setNavigationStateData,
    setCurrentLayoutAccess,
    setOrganizationId,
  } = useAuth();

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [editEnabled, setEditEnabled] = useState(false);
  const [uploadImage, setUploadImage] = useState(null);
  const [uploadImageOP, setUploadImageOP] = useState(null);
  const [orgDetail, setOrgDetail] = useState({});
  const [selected, setSelected] = useState([]);
  const [reports, setReports] = useState([]);
  const [selectedImageType, setSelectedImageType] = useState(null);

  console.log("iddd:", id.replace(":id", ""));
  console.log("orgDetail", location?.state?.orgId);
  // console.log("orgDetail", orgDetail);
  const handleImagePreviewModalOpen = (imageType = 'main') => {
    setSelectedImageType(imageType);
    setImagePreviewModal(true);
  };
  const handleImagePreviewModalClose = () => {
    setImagePreviewModal(false);
  };

  useEffect(() => {
    // Check if we have no data and no valid ID - redirect to parent page
    if (!location?.state?.orgId && (!id || id === ":id")) {
      navigate('/organizations', { replace: true });
      return;
    }

    //setOrgDetail(location.state.organizationData);
    fetchOrgDetails();
    fetchReports();
  }, [location.state, id, navigate]);

  useEffect(() => {
    setOrganizationId(null);
    localStorage.removeItem("organizationId");
  }, []);

  // Don't render anything if we don't have valid organization data
  if (!orgDetail?.id && (!location?.state?.orgId && (!id || id === ":id"))) {
    return null;
  }

  const fetchOrgDetails = async () => {
    try {
      const orgData = await getSingleOrg(
        location?.state?.orgId || id.replace(":id", "")
      );
      // const orgData = await getSingleOrg(location?.state?.organizationData?.id);
      // const userTemp = await getOrgUser(location?.state?.organizationData?.id); // Retrieve user data
      let data = {
        ...orgData?.data(),
        id: orgData.id,
        // userData: userTemp,
      };
      setOrgDetail(data);
    } catch (error) {
      console.error("Error fetching area details:", error);
    }
  };

  const fetchReports = async () => {
    let reports = await getOrganizationReports(
      location?.state?.orgId || id.replace(":id", "")
      // location.state.organizationData.id
    );
    setReports(reports);
    console.log("id", location?.state?.orgId || id.replace(":id", ""));
  };

  const handleUpdateOrganization = async () => {
    let keepEditing = false;
    try {
      setLoading(true);
      // Org handles must be unique across org handles AND usernames.
      const handleCheck = await checkOrgHandleAvailability(orgDetail?.handle, {
        excludeOrgId: orgDetail?.id,
      });
      if (!handleCheck.available) {
        Toast("error", handleCheck.message);
        keepEditing = true;
        return;
      }
      let dataTemp = {
        name: orgDetail?.name ?? "",
        handle: normalizeHandle(orgDetail?.handle),
        orgContact: orgDetail?.orgContact ?? "",
        updatedBy: currentUser?.id ?? "",
        orgEmail: orgDetail?.orgEmail ?? "",
        status: orgDetail?.status.toLowerCase() ?? "",
        phone: orgDetail?.phone ?? "",
        location: orgDetail?.location || "",
        coordinates: new GeoPoint(
          orgDetail?.coordinates?._lat || 0,
          orgDetail?.coordinates?._long || 0
        ),
        g: {
          geohash: orgDetail?.g?.geohash || "",
          geopoint: new GeoPoint(
            orgDetail?.coordinates?._lat || 0,
            orgDetail?.coordinates?._long || 0
          ),
        },
        allowAR: orgDetail?.allowAR ?? false,
        autoApproveAR: orgDetail?.autoApproveAR ?? false,
        pinOrder: orgDetail?.pinOrder ?? null,
        // Org-level feed priority (1-100, 50 = neutral). Editing this triggers a
        // background re-index of the org's quicktales/albums (onOrgWriteReindex).
        feedPriority: Math.min(
          100,
          Math.max(1, parseInt(orgDetail?.feedPriority ?? 50, 10) || 50)
        ),
      };
      if (uploadImage != null) {
        let photoUrl = await uploadOrgImageToStorage(uploadImage?.raw);
        dataTemp.logoUrl = photoUrl;
        dataTemp.originalPhotoName = uploadImage?.raw?.name;
      }
      if (uploadImageOP != null) {
        let photoUrl = await uploadOrgImageToStorage(uploadImageOP?.raw);
        dataTemp.logoOP = photoUrl;
        dataTemp.originalPhotoNameOP = uploadImageOP?.raw?.name;
      }

      await updateOrganization(orgDetail.id, dataTemp);
      await handleGetAllOrganizations();
      showNotification("Organization updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating organization", error.message);
    } finally {
      setLoading(false);
      if (!keepEditing) setEditEnabled(false);
    }
  };

  return (
    <Box sx={{ display: "flex", width: `calc(100% - ${drawerWidth}px)` }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={orgDetail && orgDetail.name && orgDetail.name}
        bgColor="#fff"
        buttonText={"Edit"}
        editEnabled={editEnabled}
        setEditEnabled={setEditEnabled}
        cancelButton={editEnabled ? true : false}
        onBackClick={() => navigate(GeneralAdminRoutes.organizations)}
        handleSave={() => handleUpdateOrganization()}
        loading={loading}
        additionalButton={
          currentUser?.role === "super" || currentUser?.role === "manager"
            ? "Access Org's Admin"
            : undefined
        }
        additionalButtonUrl={() => {
          localStorage.setItem(
            "organizationId",
            location?.state?.orgId || id.replace(":id", "")
          );
          localStorage.setItem("currentLayoutAccess", "organization");
          setCurrentLayoutAccess("organization");
          localStorage.setItem(
            "navigationRoute",
            GeneralAdminRoutes.organizationDetails
          );
          localStorage.setItem("navigationStateData", orgDetail);
          setNavigationRoute(GeneralAdminRoutes.organizationDetails);
          setNavigationStateData(orgDetail);
          setOrganizationId(location?.state?.orgId || id.replace(":id", ""));
          navigate(routes.dashboard);
        }}
      />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          {/*Data card/container section*/}
          <GAOrgDetailsDataFieldsSection
            orgDetail={orgDetail}
            setOrgDetail={setOrgDetail}
            handleImagePreviewModalOpen={handleImagePreviewModalOpen}
            editEnabled={editEnabled}
            uploadImage={uploadImage}
            setUploadImage={setUploadImage}
            uploadImageOP={uploadImageOP}
            setUploadImageOP={setUploadImageOP}
            allOrganization={allOrganization}
          />

          <GAOrgDetailTable
            selected={selected}
            setSelected={setSelected}
            orgDetail={orgDetail}
            setOrgDetail={setOrgDetail}
            setReports={setReports}
            reports={reports}
            userDetailsPageReports={true}
            detailsPageReports={true}
          />
        </Grid>
      </Grid>

      <ImagePreviewModal
        modalOpen={imagePreviewModal}
        handleClose={handleImagePreviewModalClose}
        image={
          selectedImageType === 'logo' 
            ? (uploadImageOP != null && uploadImageOP.preview
                ? uploadImageOP.preview
                : orgDetail?.logoOP)
            : (uploadImage != null && uploadImage.preview
                ? uploadImage.preview
                : orgDetail?.logoUrl)
        }
        imageOP={null}
      />
    </Box>
  );
};

export default GAOrganizationDetailsContainer;

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};
